export const aboutData = {
    title: "Who I am",
    description1: "My name's Talha Khan. I'm a PHP developer based in Islamabad, Pakistan, with a focus on Laravel and WordPress development.",
    description2: "I enjoy building clean, scalable web applications and websites that solve real problems. Alongside client projects, I work on personal side projects to sharpen my skills and explore new technologies. Outside of coding, I love learning new things and growing as a developer every day.",
    image: 1
}
